import {
	LICENSED_PRODUCTS,
	getInitialProductList,
} from '@atlassian/jira-common-util-get-tenant-context/src/index.tsx';

const isJswConfluenceBundle = (): boolean => {
	const { JIRA_SOFTWARE, CONFLUENCE } = LICENSED_PRODUCTS;
	const initialProductList = getInitialProductList();
	return (
		initialProductList !== undefined &&
		initialProductList.startsWith(`${JIRA_SOFTWARE}.ondemand,${CONFLUENCE}.ondemand`)
	);
};

export default isJswConfluenceBundle;
